[
  {
    "id": "lateral-port-a",
    "category": "lateral",
    "region": "A",
    "name": {
      "en": "Port hand mark, Region A",
      "de": "Backbordtonne, Region A"
    },
    "colours": [
      "red"
    ],
    "topmark": "cylinder-red",
    "shape": "can",
    "character": "Fl.R.4s",
    "meaning": {
      "en": "Leave the mark to port when proceeding in the conventional direction of buoyage.",
      "de": "Bei der Fahrt in der üblichen Betonnungsrichtung an Backbord lassen."
    },
    "explanation": {
      "en": "Red, flat topped, red cylinder as topmark and a red light: everything about this mark is the same signal repeated, so it reads in fog, at dusk and at night. Shape and colour are reversed in Region B.",
      "de": "Rot, stumpf, roter Zylinder als Toppzeichen und rotes Feuer: alles an dieser Tonne wiederholt dieselbe Aussage, damit sie im Dunst, in der Dämmerung und bei Nacht lesbar bleibt. In Region B sind Farbe und Form vertauscht."
    },
    "cite": {
      "see": [
        {
          "section": "B.11",
          "ids": [
            "b",
            "b.Farbe",
            "b.Form",
            "b.Toppzeichen",
            "b.Feuer.Farbe",
            "b.Feuer.Kennung"
          ]
        }
      ],
      "cfr": [
        {
          "section": "62.25",
          "ids": [
            "d"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "lateral-stbd-a",
    "category": "lateral",
    "region": "A",
    "name": {
      "en": "Starboard hand mark, Region A",
      "de": "Steuerbordtonne, Region A"
    },
    "colours": [
      "green"
    ],
    "topmark": "cone-green",
    "shape": "conical",
    "character": "Fl.G.4s",
    "meaning": {
      "en": "Leave the mark to starboard when proceeding in the conventional direction of buoyage.",
      "de": "Bei der Fahrt in der üblichen Betonnungsrichtung an Steuerbord lassen."
    },
    "explanation": {
      "en": "Green, pointed, a green cone point up as topmark, green light. The cone points the way the buoy is read: up and to starboard.",
      "de": "Grün, spitz, grüner Kegel mit der Spitze nach oben, grünes Feuer. Die Spitze zeigt, wie die Tonne gelesen wird: aufwärts und nach Steuerbord."
    },
    "cite": {
      "see": [
        {
          "section": "B.11",
          "ids": [
            "a",
            "a.Farbe",
            "a.Form",
            "a.Toppzeichen",
            "a.Feuer.Farbe",
            "a.Feuer.Kennung"
          ]
        }
      ],
      "cfr": [
        {
          "section": "62.25",
          "ids": [
            "d"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "lateral-port-b",
    "category": "lateral",
    "region": "B",
    "name": {
      "en": "Port hand mark, Region B",
      "de": "Backbordtonne, Region B"
    },
    "colours": [
      "green"
    ],
    "topmark": "can-green",
    "shape": "can",
    "character": "Fl.G.4s",
    "meaning": {
      "en": "Leave the mark to port when proceeding in the conventional direction of buoyage.",
      "de": "Bei der Fahrt in der üblichen Betonnungsrichtung an Backbord lassen."
    },
    "explanation": {
      "en": "In the Americas, Japan and Korea the colours are the other way round: green marks the port side. The shape stays the same as in Region A, a flat topped can, which is why shape is the safer cue when you change region.",
      "de": "In Amerika, Japan und Korea sind die Farben vertauscht: Grün steht an Backbord. Die Form bleibt wie in Region A stumpf, deshalb ist die Form beim Regionswechsel das sicherere Merkmal."
    },
    "cite": {
      "cfr": [
        {
          "section": "62.25",
          "ids": [
            "b(1)",
            "d"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "b(1)"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "d",
            "d(1)"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "lateral-stbd-b",
    "category": "lateral",
    "region": "B",
    "name": {
      "en": "Starboard hand mark, Region B",
      "de": "Steuerbordtonne, Region B"
    },
    "colours": [
      "red"
    ],
    "topmark": "cone-red",
    "shape": "conical",
    "character": "Fl.R.4s",
    "meaning": {
      "en": "Leave the mark to starboard when proceeding in the conventional direction of buoyage.",
      "de": "Bei der Fahrt in der üblichen Betonnungsrichtung an Steuerbord lassen."
    },
    "explanation": {
      "en": "Red nun buoys mark the starboard side in Region B. The old rule red right returning fits here and nowhere in Region A.",
      "de": "Rote Spitztonnen stehen in Region B an Steuerbord. Die Merkregel red right returning gilt hier, in Region A nicht."
    },
    "cite": {
      "cfr": [
        {
          "section": "62.25",
          "ids": [
            "b(2)",
            "d"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "b(2)"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "d",
            "d(1)"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "preferred-channel-stbd-a",
    "category": "preferred-channel",
    "region": "A",
    "name": {
      "en": "Preferred channel to starboard, Region A",
      "de": "Hauptfahrwasser rechts, Region A"
    },
    "colours": [
      "green",
      "red",
      "green"
    ],
    "topmark": "cone-green",
    "shape": "conical",
    "character": "Fl(2+1)G.10s",
    "meaning": {
      "en": "A channel divides here; the preferred channel lies to starboard of the mark.",
      "de": "Hier teilt sich das Fahrwasser; das Hauptfahrwasser liegt rechts der Tonne."
    },
    "explanation": {
      "en": "A starboard hand mark with a red band, and a light in the group two plus one rhythm. The top colour tells you which side is the main channel, the extra single flash tells you that a decision is due.",
      "de": "Eine Steuerbordtonne mit rotem Band, dazu das Feuer im Takt zwei plus eins. Die oberste Farbe sagt, wo das Hauptfahrwasser liegt, der einzelne Nachblitz sagt, dass eine Entscheidung ansteht."
    },
    "cite": {
      "see": [
        {
          "section": "B.13",
          "ids": [
            "a",
            "a.Farbe",
            "a.Form",
            "a.Toppzeichen",
            "a.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "preferred-channel-port-a",
    "category": "preferred-channel",
    "region": "A",
    "name": {
      "en": "Preferred channel to port, Region A",
      "de": "Hauptfahrwasser links, Region A"
    },
    "colours": [
      "red",
      "green",
      "red"
    ],
    "topmark": "cylinder-red",
    "shape": "can",
    "character": "Fl(2+1)R.10s",
    "meaning": {
      "en": "A channel divides here; the preferred channel lies to port of the mark.",
      "de": "Hier teilt sich das Fahrwasser; das Hauptfahrwasser liegt links der Tonne."
    },
    "explanation": {
      "en": "A port hand mark with a green band. Read the topmost colour first, then the rhythm: two flashes plus one always means a junction.",
      "de": "Eine Backbordtonne mit grünem Band. Zuerst die oberste Farbe lesen, dann den Takt: zwei Blitze plus einer heißt immer Abzweigung."
    },
    "cite": {
      "see": [
        {
          "section": "B.13",
          "ids": [
            "b",
            "b.Farbe",
            "b.Form",
            "b.Toppzeichen",
            "b.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "preferred-channel-b",
    "category": "preferred-channel",
    "region": "B",
    "name": {
      "en": "Preferred channel mark, Region B",
      "de": "Hauptfahrwassertonne, Region B"
    },
    "colours": [
      "red",
      "green"
    ],
    "topmark": "cone-red",
    "shape": "conical",
    "character": "Fl(2+1)R.10s",
    "meaning": {
      "en": "A channel divides here; the colour of the topmost band names the preferred channel.",
      "de": "Hier teilt sich das Fahrwasser; die oberste Farbe nennt das Hauptfahrwasser."
    },
    "explanation": {
      "en": "Red and green horizontal bands. Topmost band red: the mark works as a starboard hand mark for the preferred channel. Topmost band green: it works as a port hand mark.",
      "de": "Rote und grüne waagerechte Bänder. Oberstes Band rot: die Tonne wirkt für das Hauptfahrwasser wie eine Steuerbordtonne. Oberstes Band grün: sie wirkt wie eine Backbordtonne."
    },
    "cite": {
      "cfr": [
        {
          "section": "62.25",
          "ids": [
            "c"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "d",
            "d(2)"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "cardinal-north",
    "category": "cardinal",
    "region": "A",
    "name": {
      "en": "North cardinal mark",
      "de": "Nord-Kardinal-Zeichen"
    },
    "colours": [
      "black",
      "yellow"
    ],
    "topmark": "cones-up",
    "shape": "pillar",
    "character": "Q",
    "meaning": {
      "en": "Safe water lies north of the mark.",
      "de": "Nördlich der Tonne ist sicheres Wasser."
    },
    "explanation": {
      "en": "Both cones point up, and the black band sits where the cones point: on top. The light never stops flashing, because north is the top of the compass card.",
      "de": "Beide Kegel zeigen nach oben, und das schwarze Band liegt dort, wohin die Kegel zeigen: oben. Das Feuer funkelt ohne Unterbrechung, weil Nord oben auf der Rose steht."
    },
    "cite": {
      "see": [
        {
          "section": "B.15",
          "ids": [
            "a",
            "a.Farbe",
            "a.Toppzeichen",
            "a.Feuer.Farbe",
            "a.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands",
    "regionNote": {
      "en": "The United States Aids to Navigation System (33 CFR Part 62) does not describe cardinal marks at all; the wording here therefore follows the German annex, which does. Consult the chart for the region you sail in.",
      "de": "Das amerikanische System (33 CFR Part 62) beschreibt Kardinalzeichen überhaupt nicht; der Wortlaut hier folgt deshalb der deutschen Anlage, die es tut. Für die eigene Region gilt die Seekarte."
    }
  },
  {
    "id": "cardinal-east",
    "category": "cardinal",
    "region": "A",
    "name": {
      "en": "East cardinal mark",
      "de": "Ost-Kardinal-Zeichen"
    },
    "colours": [
      "black",
      "yellow",
      "black"
    ],
    "topmark": "cones-base",
    "shape": "pillar",
    "character": "Q(3).10s",
    "meaning": {
      "en": "Safe water lies east of the mark.",
      "de": "Östlich der Tonne ist sicheres Wasser."
    },
    "explanation": {
      "en": "The cones stand base to base, which looks like an egg, and east starts with the same sound. Three flashes, like three o clock on the compass card.",
      "de": "Die Kegel stehen Basis an Basis, das sieht aus wie ein Ei, und Ost liegt im Osten der Rose. Drei Funkel, wie drei Uhr auf dem Zifferblatt."
    },
    "cite": {
      "see": [
        {
          "section": "B.15",
          "ids": [
            "b",
            "b.Farbe",
            "b.Toppzeichen",
            "b.Feuer.Farbe",
            "b.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands",
    "regionNote": {
      "en": "The United States Aids to Navigation System (33 CFR Part 62) does not describe cardinal marks at all; the wording here therefore follows the German annex, which does. Consult the chart for the region you sail in.",
      "de": "Das amerikanische System (33 CFR Part 62) beschreibt Kardinalzeichen überhaupt nicht; der Wortlaut hier folgt deshalb der deutschen Anlage, die es tut. Für die eigene Region gilt die Seekarte."
    }
  },
  {
    "id": "cardinal-south",
    "category": "cardinal",
    "region": "A",
    "name": {
      "en": "South cardinal mark",
      "de": "Süd-Kardinal-Zeichen"
    },
    "colours": [
      "yellow",
      "black"
    ],
    "topmark": "cones-down",
    "shape": "pillar",
    "character": "Q(6)+LFl.15s",
    "meaning": {
      "en": "Safe water lies south of the mark.",
      "de": "Südlich der Tonne ist sicheres Wasser."
    },
    "explanation": {
      "en": "Both cones point down, the black band sits below. Six quick flashes and one long one: the long flash is there so six cannot be miscounted as five or seven.",
      "de": "Beide Kegel zeigen nach unten, das schwarze Band liegt unten. Sechs Funkel und ein langer Blitz: der lange Blitz steht da, damit sechs nicht als fünf oder sieben gezählt wird."
    },
    "cite": {
      "see": [
        {
          "section": "B.15",
          "ids": [
            "c",
            "c.Farbe",
            "c.Toppzeichen",
            "c.Feuer.Farbe",
            "c.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands",
    "regionNote": {
      "en": "The United States Aids to Navigation System (33 CFR Part 62) does not describe cardinal marks at all; the wording here therefore follows the German annex, which does. Consult the chart for the region you sail in.",
      "de": "Das amerikanische System (33 CFR Part 62) beschreibt Kardinalzeichen überhaupt nicht; der Wortlaut hier folgt deshalb der deutschen Anlage, die es tut. Für die eigene Region gilt die Seekarte."
    }
  },
  {
    "id": "cardinal-west",
    "category": "cardinal",
    "region": "A",
    "name": {
      "en": "West cardinal mark",
      "de": "West-Kardinal-Zeichen"
    },
    "colours": [
      "yellow",
      "black",
      "yellow"
    ],
    "topmark": "cones-point",
    "shape": "pillar",
    "character": "Q(9).15s",
    "meaning": {
      "en": "Safe water lies west of the mark.",
      "de": "Westlich der Tonne ist sicheres Wasser."
    },
    "explanation": {
      "en": "The cones point at each other and form a waist, like a wine glass, and W for west sits nine o clock on the compass card: nine flashes.",
      "de": "Die Kegel zeigen aufeinander und bilden eine Taille wie ein Weinglas, und West steht auf neun Uhr der Rose: neun Funkel."
    },
    "cite": {
      "see": [
        {
          "section": "B.15",
          "ids": [
            "d",
            "d.Farbe",
            "d.Toppzeichen",
            "d.Feuer.Farbe",
            "d.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "bands",
    "regionNote": {
      "en": "The United States Aids to Navigation System (33 CFR Part 62) does not describe cardinal marks at all; the wording here therefore follows the German annex, which does. Consult the chart for the region you sail in.",
      "de": "Das amerikanische System (33 CFR Part 62) beschreibt Kardinalzeichen überhaupt nicht; der Wortlaut hier folgt deshalb der deutschen Anlage, die es tut. Für die eigene Region gilt die Seekarte."
    }
  },
  {
    "id": "isolated-danger",
    "category": "isolated-danger",
    "region": "both",
    "name": {
      "en": "Isolated danger mark",
      "de": "Einzelgefahrenzeichen"
    },
    "colours": [
      "black",
      "red",
      "black"
    ],
    "topmark": "spheres-black",
    "shape": "pillar",
    "character": "Fl(2).5s",
    "meaning": {
      "en": "An isolated danger of limited extent lies here; it can be passed on all sides.",
      "de": "Hier liegt eine einzelne Gefahrenstelle von geringer Ausdehnung; sie kann an allen Seiten passiert werden."
    },
    "explanation": {
      "en": "Two black spheres, one above the other, and two flashes: the two is the whole mnemonic. The mark stands on the danger, not next to it, so keep clear.",
      "de": "Zwei schwarze Bälle übereinander und zwei Blitze: die Zwei ist die ganze Eselsbrücke. Die Tonne steht auf der Gefahr, nicht daneben, also Abstand halten."
    },
    "cite": {
      "see": [
        {
          "section": "B.15",
          "ids": [
            "e",
            "e.Farbe",
            "e.Toppzeichen",
            "e.Feuer.Farbe",
            "e.Feuer.Kennung"
          ]
        }
      ],
      "cfr": [
        {
          "section": "62.29",
          "ids": [
            "intro"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "safe-water-a",
    "category": "safe-water",
    "region": "A",
    "name": {
      "en": "Safe water mark, Region A",
      "de": "Mittefahrwasserzeichen, Region A"
    },
    "colours": [
      "red",
      "white"
    ],
    "topmark": "sphere-red",
    "shape": "spherical",
    "character": "Iso.4s",
    "meaning": {
      "en": "Navigable water all around; often the seaward end of a channel or the middle of a fairway.",
      "de": "Ringsum sicheres Wasser; oft der seewärtige Anfang eines Fahrwassers oder die Mitte eines Schifffahrtsweges."
    },
    "explanation": {
      "en": "Red and white vertical stripes, a single red sphere on top, and a light that is on as long as it is off. Vertical stripes appear on no other mark, which is how you spot it from far off.",
      "de": "Rot-weiße senkrechte Streifen, ein einzelner roter Ball obenauf, und ein Feuer, das so lang leuchtet wie es dunkel ist. Senkrechte Streifen trägt keine andere Tonne, daran erkennst du sie von weitem."
    },
    "cite": {
      "see": [
        {
          "section": "B.10",
          "ids": [
            "x.Farbe",
            "x.Form",
            "x.Toppzeichen",
            "x.Feuer.Farbe",
            "x.Feuer.Kennung"
          ]
        }
      ]
    },
    "pattern": "stripes"
  },
  {
    "id": "safe-water-b",
    "category": "safe-water",
    "region": "B",
    "name": {
      "en": "Safe water mark, Region B",
      "de": "Mittefahrwasserzeichen, Region B"
    },
    "colours": [
      "red",
      "white"
    ],
    "topmark": "sphere-red",
    "shape": "spherical",
    "character": "Mo(A).8s",
    "meaning": {
      "en": "Navigable water all around; often the seaward end of a channel or the middle of a fairway.",
      "de": "Ringsum sicheres Wasser; oft der seewärtige Anfang eines Fahrwassers oder die Mitte eines Schifffahrtsweges."
    },
    "explanation": {
      "en": "Same stripes and the same red sphere, but the light differs: in Region B a safe water mark shows Morse code A, short then long. The colours tell you the kind of mark, the rhythm tells you which side of the Atlantic you are on.",
      "de": "Dieselben Streifen und derselbe rote Ball, aber das Feuer ist anders: in Region B zeigt das Mittefahrwasserzeichen den Morsebuchstaben A, kurz und dann lang. Die Farben sagen, welche Art von Zeichen es ist, der Rhythmus sagt, auf welcher Seite des Atlantiks du bist."
    },
    "cite": {
      "cfr": [
        {
          "section": "62.27",
          "ids": [
            "intro"
          ]
        },
        {
          "section": "62.45",
          "ids": [
            "d",
            "d(3)"
          ]
        }
      ]
    },
    "pattern": "stripes"
  },
  {
    "id": "special",
    "category": "special",
    "region": "both",
    "name": {
      "en": "Special mark",
      "de": "Sonderzeichen"
    },
    "colours": [
      "yellow"
    ],
    "topmark": "cross-yellow",
    "shape": "barrel",
    "character": "Fl.Y.5s",
    "meaning": {
      "en": "Marks a special area or feature described on the chart, not a hazard to navigation in itself.",
      "de": "Kennzeichnet ein besonderes Gebiet oder eine besondere Stelle nach Seekarte, selbst keine Gefahr für die Schifffahrt."
    },
    "explanation": {
      "en": "Yellow all over, a yellow cross lying on its side as topmark, a yellow light. Yellow carries no lateral meaning at all: what the mark means is written on the chart, not on the buoy.",
      "de": "Durchgehend gelb, ein gelbes liegendes Kreuz als Toppzeichen, gelbes Feuer. Gelb trägt keine seitliche Bedeutung: was die Tonne meint, steht in der Seekarte, nicht auf der Tonne."
    },
    "cite": {
      "see": [
        {
          "section": "B.16",
          "ids": [
            "x.Farbe",
            "x.Form",
            "x.Toppzeichen",
            "x.Feuer.Farbe",
            "x.Feuer.Kennung"
          ]
        }
      ],
      "cfr": [
        {
          "section": "62.31",
          "ids": [
            "intro"
          ]
        }
      ]
    },
    "pattern": "bands"
  },
  {
    "id": "mooring",
    "category": "mooring",
    "region": "A",
    "name": {
      "en": "Mooring buoy",
      "de": "Festmachetonne"
    },
    "colours": [
      "yellow"
    ],
    "topmark": "none",
    "shape": "barrel",
    "meaning": {
      "en": "A buoy you are allowed to make fast to.",
      "de": "Tonne, an der festgemacht werden darf."
    },
    "explanation": {
      "en": "Yellow like a special mark, but without a topmark and lettered. It is furniture, not a navigation mark, and it does not tell you anything about the water around it.",
      "de": "Gelb wie ein Sonderzeichen, aber ohne Toppzeichen und beschriftet. Sie ist Ausrüstung, kein Navigationszeichen, und sagt nichts über das Wasser ringsum."
    },
    "cite": {
      "see": [
        {
          "section": "B.17",
          "ids": [
            "x.Farbe",
            "x.Form",
            "x.Beschriftung"
          ]
        }
      ]
    },
    "pattern": "bands"
  }
]
